import script from "./RessourceLink.vue?vue&type=script&setup=true&lang=js"
export * from "./RessourceLink.vue?vue&type=script&setup=true&lang=js"

import "./RessourceLink.vue?vue&type=style&index=0&id=d2e8f330&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2e8f330"]])

export default __exports__